/**
 * Presentación de los puntos.
 *
 * El backend guarda y devuelve CENTIPUNTOS: enteros ×100, porque los multiplicadores de
 * racha producen decimales (25 × 1,1 = 27,5) y con coma flotante dos usuarios empatados
 * podrían ordenarse distinto entre recargas (D6 de motor-puntos.md).
 *
 * El redondeo es cosa de esta capa y de ninguna otra. Aquí NO se calcula nada: solo se
 * divide entre 100 para pintar.
 */

/**
 * 5200 -> "52", 5250 -> "52,5", 5205 -> "52,05" (en francés).
 *
 * Se recortan los ceros finales a propósito: una tabla llena de "52,00" y "10,00" se
 * lee peor, y la mayoría de los totales son enteros. Los decimales aparecen solo cuando
 * los hay, que es justo cuando importan para entender un empate.
 */
export function formatearPuntos(centipuntos: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(centipuntos / 100);
}
